export const enum StatusGroup {
  Multiple = "Groups of Multiple Statuses",
  Success = "Success Status",
  Warning = "Warning Status",
  Error = "Error Status",
}
